__turbopack_context__.v({
  "copy": "StoreItem-module-scss-module__rLhpdq__copy",
  "details": "StoreItem-module-scss-module__rLhpdq__details",
  "icon": "StoreItem-module-scss-module__rLhpdq__icon",
  "item": "StoreItem-module-scss-module__rLhpdq__item",
  "outOfStock": "StoreItem-module-scss-module__rLhpdq__outOfStock",
  "row": "StoreItem-module-scss-module__rLhpdq__row",
  "srOnly": "StoreItem-module-scss-module__rLhpdq__srOnly",
  "status": "StoreItem-module-scss-module__rLhpdq__status",
  "statusText": "StoreItem-module-scss-module__rLhpdq__statusText",
  "storeName": "StoreItem-module-scss-module__rLhpdq__storeName",
});
